/* MOVA CRO TEST 1: BLOCO DE CONFIANCA
 * Controle: bloco .mova-compact-box oculto
 * Variante: bloco atual visivel
 * Persistencia: localStorage por visitante
 * QA: ?mova_t1=controle ou ?mova_t1=bloco
 */
(function () {
  'use strict';
  if (!/^\/products\//.test(window.location.pathname)) return;

  var experimentId = 'mova_trust_block_v1';
  var storageKey = 'mova_exp_' + experimentId;
  var params = new URLSearchParams(window.location.search);
  var forced = params.get('mova_t1');
  var variant;

  if (forced === 'controle' || forced === 'control') {
    variant = 'control';
  } else if (forced === 'bloco' || forced === 'trust') {
    variant = 'trust_block';
  } else {
    try { variant = window.localStorage.getItem(storageKey); } catch (error) {}
    if (variant !== 'control' && variant !== 'trust_block') {
      variant = Math.random() < 0.5 ? 'control' : 'trust_block';
      try { window.localStorage.setItem(storageKey, variant); } catch (error) {}
    }
  }

  document.documentElement.setAttribute('data-mova-test-1', variant);
  if (variant === 'control') {
    var style = document.createElement('style');
    style.id = 'mova-test-1-style';
    style.textContent = 'html[data-mova-test-1="control"] .mova-compact-box{display:none!important}';
    document.head.appendChild(style);
  }

  var impression = {
    event: 'mova_experiment_impression',
    experiment_id: experimentId,
    experiment_variant: variant,
    page_path: window.location.pathname
  };
  window.movaExperimentQueue = window.movaExperimentQueue || [];
  window.movaExperimentQueue.push(impression);

  var attempts = 0;
  function publishImpression() {
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(impression);
      return;
    }
    attempts += 1;
    if (attempts < 20) window.setTimeout(publishImpression, 250);
  }
  publishImpression();
})();

/* MOVA CHECKOUT: fallback resiliente para o carrinho lateral.
 * A UnicoPag substitui esta funcao quando a integracao principal inicializa.
 * Este fallback cobre o intervalo (ou falha) em que a funcao global ainda
 * nao existe, preservando o carrinho como destino seguro em qualquer erro.
 */
(function () {
  'use strict';

  window.movaDirectCheckoutFallbackLoaded = true;

  var isRedirecting = false;
  var statusEndpoint = 'https://api.unicopag.com.br/api/api/integrations/shopify/check?shop=e1u6zh-tj.myshopify.com';

  function getCookie(name) {
    var prefix = name + '=';
    var cookies = document.cookie.split(';');

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();
      if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length);
    }

    return '';
  }

  function addTracking(url) {
    try {
      var checkoutUrl = new URL(url);
      var storedUtms = getCookie('utmsTrack');
      var googleAnalyticsId = getCookie('_ga');
      var upSession = window.localStorage.getItem('_upsession');

      if (storedUtms) {
        new URLSearchParams(storedUtms).forEach(function (value, key) {
          checkoutUrl.searchParams.set(key, value);
        });
      }

      if (googleAnalyticsId) checkoutUrl.searchParams.set('_ga', googleAnalyticsId);
      if (upSession) checkoutUrl.searchParams.set('_upsession', upSession);

      return checkoutUrl.href;
    } catch (error) {
      return url;
    }
  }

  function showLoader() {
    var loader = document.querySelector('.unico-loader');
    if (loader) loader.style.display = 'block';
  }

  function goToCart() {
    window.location.assign(window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');
  }

  function requestJson(url) {
    return window.fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Request failed: ' + response.status);
      return response.json();
    });
  }

  function buildCheckoutUrl(cart, integration) {
    var domain = integration.custom_domain
      ? 'https://' + integration.custom_domain
      : 'https://pay.unicopag.com.br';
    var checkoutUrl = new URL(domain.replace(/\/$/, '') + '/' + cart.items[0].variant_id);
    var multiple = cart.items.map(function (item) {
      return item.id + ':' + item.quantity;
    }).join(',');
    var customOptions = cart.items.map(function (item) {
      return item.id + ':-:' + JSON.stringify(item.properties || {});
    }).join('::');

    checkoutUrl.searchParams.set('multiple', multiple);
    checkoutUrl.searchParams.set('custom_options', customOptions);

    return addTracking(checkoutUrl.href);
  }

  function fallbackDirectCheckout(event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    if (isRedirecting) return;

    isRedirecting = true;
    showLoader();

    Promise.all([
      requestJson('/cart.js'),
      requestJson(statusEndpoint)
    ]).then(function (results) {
      var cart = results[0];
      var integration = results[1];

      if (!cart.items || !cart.items.length || !integration.active) {
        goToCart();
        return;
      }

      window.location.assign(buildCheckoutUrl(cart, integration));
    }).catch(function () {
      goToCart();
    });
  }

  fallbackDirectCheckout.movaFallback = true;

  function installFallback() {
    if (typeof window.movaUnicoDirectCheckout !== 'function') {
      window.movaUnicoDirectCheckout = fallbackDirectCheckout;
    }
  }

  installFallback();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installFallback, { once: true });
  }

  window.setTimeout(installFallback, 500);
  window.setTimeout(installFallback, 2000);

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest && event.target.closest('#CartDrawer-Checkout');

    if (!checkoutButton || checkoutButton.hasAttribute('disabled')) return;
    if (typeof window.movaUnicoDirectCheckout === 'function') return;

    event.preventDefault();
    fallbackDirectCheckout(event);
  }, true);

})();

(function () {
  'use strict';

  function getContainers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    return Array.prototype.map.call(scope.querySelectorAll('ul.custom--tabs'), function (tabsList) {
      return tabsList.parentElement;
    }).filter(Boolean);
  }

  function activateTab(container, tab) {
    var tabs = container.querySelectorAll('.lumin-custom-tab');
    var contents = container.querySelectorAll('.lumin-custom__tab-content');
    var contentId = tab.dataset.contentId;

    tabs.forEach(function (item) {
      var active = item === tab;
      item.classList.toggle('active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    contents.forEach(function (content) {
      content.classList.toggle('active', content.id === contentId);
    });
  }

  function bindContainer(container) {
    var originalTabs = Array.prototype.slice.call(container.querySelectorAll('.lumin-custom-tab'));
    var contents = container.querySelectorAll('.lumin-custom__tab-content');

    originalTabs.forEach(function (original, index) {
      var tab = original;

      if (tab.dataset.movaQaClean !== 'true') {
        tab = original.cloneNode(true);
        original.replaceWith(tab);
        tab.dataset.movaQaClean = 'true';
      }

      if (tab.dataset.movaQaBound === 'true') return;
      tab.dataset.movaQaBound = 'true';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', tab.classList.contains('active') ? 'true' : 'false');
      tab.setAttribute('tabindex', tab.classList.contains('active') ? '0' : '-1');

      var content = document.getElementById(tab.dataset.contentId);
      if (content) content.setAttribute('role', 'tabpanel');

      tab.addEventListener('click', function () {
        activateTab(container, tab);
      });

      tab.addEventListener('keydown', function (event) {
        var tabs = Array.prototype.slice.call(container.querySelectorAll('.lumin-custom-tab'));
        var currentIndex = tabs.indexOf(tab);
        var nextIndex = currentIndex;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activateTab(container, tab);
          return;
        }

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;

        if (nextIndex !== currentIndex) {
          event.preventDefault();
          tabs[nextIndex].focus();
          activateTab(container, tabs[nextIndex]);
        }
      });
    });

    contents.forEach(function (content) {
      content.setAttribute('role', 'tabpanel');
    });
  }

  function setupTabs(root) {
    getContainers(root).forEach(bindContainer);
  }

  try {
    if (typeof observer !== 'undefined' && observer && typeof observer.disconnect === 'function') {
      observer.disconnect();
    }
  } catch (error) {
    // The section observer may not exist on pages without tabs.
  }

  window.initializeTabs = function () {
    setupTabs(document);
  };

  setupTabs(document);
  document.addEventListener('shopify:section:load', function (event) {
    setupTabs(event.target);
  });
})();
